import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'va-nav-item-list',
  templateUrl: './nav-item-list.component.html',
  styleUrls: ['./nav-item-list.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class VaNavItemListComponent implements OnInit, AfterViewInit {
  @Input() label: string;
  @Input() icon: string;
  @Input() isSvg = false;
  @Input() startExpanded = false;

  @ViewChild('submenu', { static: true }) submenu: ElementRef;

  menuHeight: string;

  _isOpen = false;
  get isOpen(): boolean {
    return this._isOpen;
  }
  set isOpen(open: boolean) {
    this._isOpen = open;
    this.updateRendererStyle(open);
  }

  updateRendererStyle(open: boolean): void {
    if (open) {
      this.renderer.setStyle(this.submenu.nativeElement, 'margin-top', '0');
    } else {
      this.renderer.setStyle(this.submenu.nativeElement, 'margin-top', this.menuHeight);
    }
  }

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this._isOpen = this.startExpanded;
  }

  ngAfterViewInit(): void {
    this.menuHeight = -this.submenu.nativeElement.offsetHeight + 'px';
    this.updateRendererStyle(this.isOpen);
  }

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }
}
